import { inject, Injectable } from '@angular/core';
import { InitStore } from '@app2/store/init/init.store';

@Injectable()
export class AgreementFacade {

  private store = inject(InitStore);

  onClick(param: string) {
    if (param === 'agree') {
      this.store.setIsUserAdult(true);
    } else {
      window.location.replace('https://google.com');
    }
  }
}
